<mat-card-title-group>
  <div class="img-container">
    <img
      mat-card-sm-image
      alt="{{ guideline.name }}"
      src="{{ guideline.logo }}"
    />
  </div>
  <mat-card-content class="content-container">
    <div
      *ngIf="
        (
          languages
          | filterSupportedLangByCode: guideline.id:translateService.currentLang
        ).length > 0
      "
      class="supported-lang-container"
    >
      <ng-container
        *ngFor="
          let langSpan of languages
            | filterSupportedLangByCode
              : guideline.id
              : translateService.currentLang
        "
      >
        <button
          mat-flat-button
          color="primary"
          class="badge-btn lang-item"
          type="button"
          (click)="switchLang(langSpan)"
        >
          {{ langSpan | uppercase }}
        </button>
      </ng-container>
    </div>
    <mat-card-title>{{ getName() }}</mat-card-title>
    <div [innerHTML]="getDescription() | sanitizer: 'html'"></div>
  </mat-card-content>
</mat-card-title-group>
